import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "Icon",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10 1.667A8.333 8.333 0 1 0 18.334 10 8.343 8.343 0 0 0 10 1.667Zm.893 12.5a.893.893 0 0 1-1.786 0V10a.893.893 0 0 1 1.786 0v4.167ZM10 7.619a1.19 1.19 0 1 1 0-2.38 1.19 1.19 0 0 1 0 2.38Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }